import './index.scss';
import Quiz from '../Quiz';
import Calculator from '../Calculator';

function QuizPage() {
   

  
  return (<>
   
    <div className="QuizPage">
        
        <Quiz></Quiz>
        <Calculator></Calculator>
    </div>
    </>
  );
}

export default QuizPage;
